import React from 'react';
import { Modal, Button } from 'antd';
import OrderConfirmModalFooter from '../confirm-modal/OrderConfirmModalFooter';

export default function OrderDispatchConfirmModal({
  open,
  onCancel,
  onConfirmYes,
  onConfirmNo,
  onMoveBack,
  order,
  loading,
}) {
  return (
    <Modal
      title="Dispatch order"
      className="order-confirm-modal"
      width={480}
      open={!!open}
      onCancel={onCancel}
      footer={(
        <OrderConfirmModalFooter>
          <Button
            type="primary"
            onClick={onConfirmYes}
            loading={loading}
            className="app-btn-primary"
          >
            हाँ, डिस्पैच
          </Button>
          <Button
            onClick={onConfirmNo}
            loading={loading}
            className="app-btn-cancel"
          >
            नहीं
          </Button>
          <Button onClick={onMoveBack} loading={loading} className="app-btn-cancel">
            पीछे भेजें (Pending)
          </Button>
        </OrderConfirmModalFooter>
      )}
      destroyOnClose
    >
      {order && (
        <>
          क्या आप इस ऑर्डर को डिस्पैच के लिए भेजना चाहते हैं?
          {order.orderNumber && (
            <> (Order <strong>{order.orderNumber}</strong>)</>
          )}
        </>
      )}
    </Modal>
  );
}
